import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL, useAuth } from "../App";

function EmployeePortal() {
	const { user } = useAuth();
	const [upcomingShifts, setUpcomingShifts] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		loadData();
	}, []);

	const loadData = async () => {
		try {
			const today = new Date();
			const startDate = today.toISOString().split("T")[0];
			const endDate = new Date(
				today.getFullYear(),
				today.getMonth() + 1,
				today.getDate(),
			)
				.toISOString()
				.split("T")[0];

			const scheduleRes = await axios.get(
				`${API_URL}/schedules/my-schedule?startDate=${startDate}&endDate=${endDate}`,
			);

			setUpcomingShifts(scheduleRes.data.slice(0, 10));
		} catch (error) {
			console.error("Error loading data:", error);
		} finally {
			setLoading(false);
		}
	};

	if (loading) {
		return (
			<div className='loading-container'>
				<div className='spinner'></div>
			</div>
		);
	}

	const today = new Date();
	const formattedDate = today.toLocaleDateString("en-US", {
		weekday: "long",
		year: "numeric",
		month: "long",
		day: "numeric",
	});

	return (
		<div>
			<div className='page-header'>
				<div>
					<h1 className='page-title'>
						Welcome, {user?.firstName || user?.username}!
					</h1>
					<p className='text-muted text-sm'>{formattedDate}</p>
				</div>
			</div>

			<div className='stats-grid'>
				<div className='stat-card primary'>
					<div className='stat-label'>Upcoming Shifts</div>
					<div className='stat-value'>{upcomingShifts.length}</div>
				</div>
			</div>

			<div className='card'>
				<div className='card-header'>
					<h3>Upcoming Shifts</h3>
					<a href='/my-schedule' className='btn btn-sm btn-secondary'>
						View All
					</a>
				</div>
				{upcomingShifts.length === 0 ? (
					<p
						className='text-muted text-center'
						style={{ padding: "1rem" }}
					>
						No upcoming shifts scheduled.
					</p>
				) : (
					<div
						style={{
							display: "flex",
							flexDirection: "column",
							gap: "0.5rem",
						}}
					>
						{upcomingShifts.map((shift, idx) => (
							<div
								key={idx}
								style={{
									padding: "0.75rem",
									background: "var(--gray-50)",
									borderRadius: "var(--radius-md)",
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
								}}
							>
								<div>
									<div className='font-medium'>
										{new Date(
											shift.schedule_date,
										).toLocaleDateString("en-US", {
											weekday: "short",
											month: "short",
											day: "numeric",
										})}
									</div>
									<div className='text-sm text-muted'>
										{shift.shift_start} - {shift.shift_end}
									</div>
								</div>
								<span className='badge badge-primary'>
									{shift.department_name}
								</span>
							</div>
						))}
					</div>
				)}
			</div>

			<div className='card'>
				<div className='card-header'>
					<h3>Quick Actions</h3>
				</div>
				<div className='flex gap-md' style={{ flexWrap: "wrap" }}>
					<a href='/my-schedule' className='btn btn-primary'>
						View Full Schedule
					</a>
				</div>
			</div>
		</div>
	);
}

export default EmployeePortal;
